import React, { useEffect, useState } from "react";

const teamMembers = [
  { name: "T Bharath Mani Kumar", role: "Software Engineer", roleColor: "text-orange-500", img: "/adhithya_it_team-9.jpeg" },
   { name: "Shireesha", role: "Software Engineer", roleColor: "text-yellow-500", img: "/adhithya_it_team-15.jpeg" },
  { name: "Sundar", role: "Sr Software Engineer(Team lead) ", roleColor: "text-gray-800", img: "/adhithya_it_team-11.png"},
  { name: "Gorle Ruchitha", role: "Software Engineer", roleColor: "text-teal-500", img: "/adhithya_it_team-2.jpeg" },
  { name: "Dappu Jashwini", role: "Software Engineer", roleColor: "text-blue-500", img: "/adhithya_it_team-3.jpeg" },
  { name: "Srikanth Singati", role: "Software Engineer", roleColor: "text-pink-500", img: "/adhithya_it_team-4.jpeg" },
  { name: "K Kalyan Chakravarthy", role: "Software Engineer", roleColor: "text-green-500", img: "/adhithya_it_team-5.jpeg" },
  { name: "Vislavath Ganesh", role: "Software Engineer", roleColor: "text-purple-500", img: "/adhithya_it_team-6.jpeg" },
  { name: "A U V N Phani Kumar", role: "Software Engineer", roleColor: "text-red-500", img: "/adhithya_it_team-8.jpeg" },
  { name: "Gulfisha Anjum", role: "Software Engineer", roleColor: "text-blue-500", img: "/adhithya_it_team-1.jpeg" },
  { name: "A Sai Keerthana", role: "Software Engineer", roleColor: "text-teal-500", img: "/adhithya_it_team-10.jpg" },
  { name: "Gandu Hema", role: "Software Engineer", roleColor: "text-indigo-500", img: "/adhithya_it_team-7.jpeg" },
  { name: "Phani Vardhan", role: "HR Manager", roleColor: "text-teal-500", img: "/adhithya_it_team-12.jpeg" },
];

const OurTeam = () => {
  const [currentIndex, setCurrentIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % teamMembers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const getIndex = (offset) => (currentIndex + offset + teamMembers.length) % teamMembers.length;


  const positions = [
    getIndex(-2),
    getIndex(-1),
    getIndex(0),
    getIndex(1),
    getIndex(2),
  ];

  return (
    <section className="py-12 text-center">
      <h2 className="text-3xl font-semibold mb-12">Our Team Members</h2>

      <div className="hidden sm:flex justify-center items-end gap-6 md:gap-10 flex-nowrap">
        {positions.map((posIndex, idx) => {
          const member = teamMembers[posIndex];
        
          const isMiddle = idx === 2;
          
          const sizeClass = isMiddle ? "w-48 h-48 md:w-56 md:h-56" : "w-32 h-32 md:w-36 md:h-36";
          const borderColor = isMiddle ? "border-purple-600" : "border-yellow-400";
          const fontSizeName = isMiddle ? "text-lg md:text-xl font-bold" : "text-sm md:text-lg font-medium";
          const fontSizeRole = isMiddle ? "text-sm md:text-base font-semibold" : "text-xs md:text-sm font-semibold";
          const containerClass = isMiddle ? "shadow-xl" : "";

          return (
            <div key={member.name} className={`flex flex-col items-center transition-transform duration-500 ${isMiddle ? "scale-110 z-20" : "scale-90 z-10"}`}>
              <div className={`border-8 rounded-full overflow-hidden ${borderColor} ${sizeClass} ${containerClass}`}>
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full object-cover object-top rounded-full"
                />
              </div>
              <h3 className={`${fontSizeName} mt-4`}>{member.name}</h3>
              <p className={`${member.roleColor} ${fontSizeRole}`}>{member.role}</p>
            </div>
          );
        })}
      </div>

      <div className="sm:hidden flex flex-col items-center mt-8 gap-6">
        <div className="flex flex-col items-center">
          <div className="w-40 h-40 border-8 border-purple-600 rounded-full overflow-hidden shadow-xl">
            <img
              src={teamMembers[currentIndex].img}
              alt={teamMembers[currentIndex].name}
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <h3 className="mt-3 text-lg font-bold">{teamMembers[currentIndex].name}</h3>
          <p className={`${teamMembers[currentIndex].roleColor} text-sm font-semibold`}>{teamMembers[currentIndex].role}</p>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
